(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["predictive-search-empty"]) return;
  try {
    
(function () {
  var modal = document.getElementById('search-modal');
  if (!modal) return;

  /* Move chips from AJAX content area to the persistent .pse-modal-terms container above it */
  var contentDiv = modal.querySelector('.predictive-search-form__content');
  var termsTarget = modal.querySelector('.pse-modal-terms');

  function liftChips() {
    if (!contentDiv || !termsTarget) return;
    var chips = contentDiv.querySelector('.pse-terms-section');
    if (!chips) return;
    termsTarget.innerHTML = '';
    termsTarget.appendChild(chips);
  }

  if (contentDiv) {
    var observer = new MutationObserver(liftChips);
    observer.observe(contentDiv, { childList: true, subtree: true });
  }

  /* Always load the configured empty state (popular terms + products) on first dialog open */
  modal.addEventListener('dialog:open', function () {
    var ps = modal.querySelector('predictive-search-component');
    if (ps && typeof ps.resetSearch === 'function') {
      ps.resetSearch(false);
    }
  }, { once: true });

  /* Chip click: fill the search input and trigger live search */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.pse-chip');
    if (!chip) return;

    var term = chip.dataset.searchTerm;
    if (!term) return;

    var input = modal.querySelector('.search-input');
    if (!input) return;

    input.value = term;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
  });


})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
document.addEventListener('click', function (e) {
  // --- Variant button ---
  const variantBtn = e.target.closest('.variant-btn');
  if (variantBtn) {
    const card = variantBtn.closest('.cs-product');
    if (!card) return;

    card.querySelectorAll('.variant-btn').forEach(function (btn) {
      btn.classList.remove('active');
    });
    variantBtn.classList.add('active');

    const img = card.querySelector('.main-image');
    if (img && variantBtn.dataset.image) img.src = variantBtn.dataset.image;

    const priceEl = card.querySelector('.pp-prices .price');
    if (priceEl && variantBtn.dataset.price) priceEl.textContent = variantBtn.dataset.price;

    const compareEl = card.querySelector('.compare-price s');
    if (compareEl && variantBtn.dataset.compare) compareEl.textContent = variantBtn.dataset.compare;

    const addBtn = card.querySelector('.add-to-cart-btn');
    if (addBtn && variantBtn.dataset.id) addBtn.dataset.variantId = variantBtn.dataset.id;

    const pricesWrapper = card.querySelector('.pp-prices');
    if (pricesWrapper) {
      pricesWrapper.classList.toggle(
        'compare-available',
        !!(variantBtn.dataset.compare && variantBtn.dataset.compare !== variantBtn.dataset.price)
      );
    }
    return;
  }

});

  } catch(e) { console.error(e); }
})();
})();
